import React, { useRef } from 'react'
import { useTargetHiddenOnScroll } from 'hooks/useTargetHiddenOnScroll'
import { useTimerForTarget } from 'modules/purchase/hooks/useTimerForTarget'
import { useTranslation } from 'react-i18next'
import { FIFTEEN_MINUTES_IN_SECONDS } from 'modules/purchase/constants'
import { StyledSubheaderWithTimer as S } from './SubheaderWithTimer.styles'

type TProps = {
  onButtonClick: () => void
  elemForComparisonRef: React.RefObject<HTMLDivElement>
}

export const SubheaderWithTimer: React.FC<TProps> = ({
  elemForComparisonRef,
  onButtonClick,
}) => {
  const { t } = useTranslation()
  const timerElementRef = useRef<HTMLSpanElement>(null)
  const isButtonVisible = useTargetHiddenOnScroll(elemForComparisonRef)

  useTimerForTarget(timerElementRef, FIFTEEN_MINUTES_IN_SECONDS)

  return (
    <S.TimerContainer isButtonVisible={isButtonVisible}>
      <S.TimerText isButtonVisible={isButtonVisible}>
        {t`purchase.subheaderText`}
      </S.TimerText>
      <S.Wrapper isButtonVisible={isButtonVisible}>
        <strong ref={timerElementRef} />
        {isButtonVisible && t`purchase.timeUnits`}
      </S.Wrapper>
      <S.TimerText isButtonVisible={isButtonVisible}>
        {t`purchase.subheaderTimeUnit`}
      </S.TimerText>
      <S.ButtonContainer isButtonVisible={isButtonVisible}>
        <S.TimerButton onClick={onButtonClick}>
          {t`actions.startNow`}
        </S.TimerButton>
      </S.ButtonContainer>
    </S.TimerContainer>
  )
}
